import { StandardContentCardInfoDropdown } from "./StandardContentCardInfoDropdown";

export default StandardContentCardInfoDropdown;
